module.exports = __webpack_public_path__ + "img/bangladesh.d90131c1.svg";